export const GET_VLEARN_APP_URL_REQUEST = 'GET_VLEARN_APP_URL_REQUEST';
export const GET_VLEARN_APP_URL_SUCCESS = 'GET_VLEARN_APP_URL_SUCCESS';
export const GET_VLEARN_APP_URL_FAILURE = 'GET_VLEARN_APP_URL_FAILURE';
